import { render, staticRenderFns } from "./approve.vue?vue&type=template&id=54057d1d&scoped=true&"
import script from "./approve.vue?vue&type=script&lang=ts&"
export * from "./approve.vue?vue&type=script&lang=ts&"
import style0 from "./approve.vue?vue&type=style&index=0&id=54057d1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54057d1d",
  null
  
)

export default component.exports